import requests from "../request";

// // 区块接口

// export const cmsBlock = (data) => {
//     return requests({
//         url: "/api/cms_block/index",
//         method: "post",
//         params: data
//     })
// }

// // 获取栏目列表
// export const cmsChannel = (data) => {
//     return requests({
//         url: "/api/cms_channel/index",
//         method: "post",
//         params: data
//     })
// }



// // 内容模型
// export const cmsModel = (data) => {
//     return requests({
//         url: "/api/cms_special/index",
//         method: "post",
//         params: data
//     })
// }


// // 资讯列表
// export const cmsArchives = (data) => {
//     return requests({
//         url: "/api/cms_archives/index",
//         method: "post",
//         params: data
//     })
// }


// // 获取文章标题
// export const cmsArticle = (data) => {
//     return requests({
//         url: "/api/cms_archives/view",
//         method: "post",
//         data
//     })
// }
// // 获取文章内容
// export const cmsArticleContent = (data) => {
//     return requests({
//         url: "/api/cms_addonwz/view",
//         method: "post",
//         data
//     })
// }

// 获取banner配置接口
export const getBannerConfig = (data) => {
    return requests({
        url: "/api/ks_config/index",
        method: "post",
        params: data
    })
}

// 获取新闻资讯文章列表
export const getXinwenArticle = (data) => {
    return requests({
        url: "/api/xinwen_article/index",
        method: "post",
        params: data
    })
}

// 获取考试数据接口
export const getExamData = (data) => {
    return requests({
        url: "/api/examdata/index",
        method: "get",
        params: data
    })
}

// 获取buildPage页面数据
export const getBuildPageData = (params) => {
    return requests({
        url: '/api/buildpage/index',
        method: 'get',
        params
    })
}

// 获取列表数据接口
export const getListData = (data) => {
    return requests({
        url: "/api/listdata/index",
        method: "get",
        params: data
    })
}

// 获取文章详情接口
export const getArticleDetail = (data) => {
    return requests({
        url: "/api/articledetail/index",
        method: "get",
        params: data
    })
}

// 获取导航数据接口
export const getBannerNav = (data) => {
    return requests({
        url: "/api/bannernav/index",
        method: "post",
        params: data
    })
}

// 获取封面数据接口（新接口）
export const getCoverData = (data) => {
    return requests({
        url: "/api/coverdata/index",
        method: "get",
        params: data
    })
}

// 获取考试时间接口
export const getExamTimeData = (data) => {
    return requests({
        url: "/api/zileidata/index",
        method: "get",
        params: data
    })
}

// 获取授课团队接口
export const getTeacherList = (data) => {
    return requests({
        url: "/api/teacher/index",
        method: "get",
        params: data
    })
}

// 获取试听课程接口
export const getCourseData = (data) => {
    return requests({
        url: "/api/course/index",
        method: "get",
        params: data
    })
}

// 获取网站配置信息（标题、关键词、描述）
export const getWebsiteConfig = () => {
    return requests({
        url: "/api/websiteconfig/index",
        method: "get"
    })
}